module.exports = __webpack_public_path__ + "img/purple-gift.33db88c3.png";